import { render, staticRenderFns } from "./ReportSpecialistList.vue?vue&type=template&id=2fb56f14&scoped=true&"
import script from "./ReportSpecialistList.vue?vue&type=script&lang=js&"
export * from "./ReportSpecialistList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fb56f14",
  null
  
)

export default component.exports